//TODO Удалить после завершения эксперимента CD-41676
import * as React from 'react';

import {
  IBuildingTypesConfig
} from '../../../../models/filters/building_types';
import { ISearchConfig } from '../../../../models/search';

import { checkboxClick } from './tracking';

import * as style from './newbuilding_building_type_filter.css';

interface IProps {
  value: string;
  type: string;
  buildingTypes: IBuildingTypesConfig;
  searchConfig: ISearchConfig;
  isShortMode?: boolean;
  customButtonText?: string;

  onChange(value: string): void;
}

interface IState {
  new_flat?: boolean;
  secondary_flat?: boolean;
}

export class NewbuildingBuildingTypeFilter extends React.Component<IProps, IState> {
  public constructor(props: IProps) {
    super(props);

    this.state = {
      new_flat: true,
      secondary_flat: true,
    };
  }

  public render() {
    return (
      <div
        className={style['c-newbuilding-filters-field']}
      >
        <label className={style['c-filters-checkbox-lbl']}>
          <input
            role="checkbox"
            type="checkbox"
            aria-checked={this.state.new_flat}
            checked={this.state.new_flat}
            name="property-type"
            className={style['c-filters-checkbox-input']}
            defaultChecked={this.state.new_flat}
            onClick={() => {
              return this.onClick('new_flat');
            }}
          />
          <span className={style['c-filters-checkbox-box']}>
            Новостройка
          </span>
        </label>
        <label className={style['c-filters-checkbox-lbl']}>
          <input
            role="checkbox"
            type="checkbox"
            aria-checked={this.state.secondary_flat}
            checked={this.state.secondary_flat}
            name="property-type"
            className={style['c-filters-checkbox-input']}
            defaultChecked={this.state.secondary_flat}
            onClick={() => {
              this.onClick('secondary_flat');
            }}
          />
          <span className={style['c-filters-checkbox-box']}>
            Вторичка
          </span>
        </label>
      </div>
    );
  }

  private onClick(value: 'new_flat' | 'secondary_flat'): void {
    this.setState({[value]: !this.state[value]});

    const anotherValue = value === 'new_flat' ? 'secondary_flat' : 'new_flat';
    let sendValue: string = !this.state[value] ? value : anotherValue;
    if (this.state[anotherValue] === !this.state[value]) {
      sendValue = 'flat';
    }

    checkboxClick(sendValue);

    return this.props.onChange(sendValue);
  }
}
